import { ApiPath } from 'enums';
import { Delete, Get, Post } from 'utils';

export const getTransactions = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Transaction}`, query);
  return res.data;
};

export const deleteTransactionByBatch = async ({ ...query }) => {
  const res = await Delete(`${ApiPath.Transaction}/batch/${query.batchId}`);
  return res.data;
};

export const getTransactionsTrialBalance = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Transaction}/trial-balance`, query);
  return res.data;
};

export const getLatestCashVoucherTransaction = async () => {
  const res = await Get(`${ApiPath.Transaction}/cash-voucher/latest`);
  return res.data;
};

export const getDashboard = async () => {
  const res = await Get(`${ApiPath.TransactionDashboard}`);
  return res.data;
};

export const getDashboard2 = async () => {
  const res = await Get(`${ApiPath.TransactionDashboard2}`);
  return res.data;
};

export const getDashboard3 = async () => {
  const res = await Get(`${ApiPath.TransactionDashboard3}`);
  return res.data;
};

export const createBatchTransaction = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Transaction}/batch`, body);
  return res.data;
};

export const getTransactionCustomersByBatchId = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Transaction}/customers/batch/${query.batchId}`, query);
  return res.data;
};
